import {PaperButton} from '../../../shared/sticker/stickers';
import {firstNameOf} from '../../../shared/utils/displayName';

export const NiceTryDialog = ({name, onClose}: {name: string; onClose: () => void}) => (
    <div className="ph-overlay">
        <div
            className="ph-nicetry"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="ph-nicetry-title"
        >
            <h2 id="ph-nicetry-title" className="ph-nicetry__title">
                NICE TRY
            </h2>
            <p>You can't vote for yourself, {firstNameOf(name)}.</p>
            <PaperButton variant="ghost" onClick={onClose}>
                Fine...
            </PaperButton>
        </div>
    </div>
);
